"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeCustomerCouponStatus = exports.StripeProduct = void 0;
var StripeProduct;
(function (StripeProduct) {
    StripeProduct["LIVE"] = "product_live";
    StripeProduct["KVIX_CURRENCY"] = "product_currency";
    StripeProduct["WELLSTAR"] = "wellstar_2021";
    StripeProduct["HABIT66"] = "product_habit66";
})(StripeProduct = exports.StripeProduct || (exports.StripeProduct = {}));
var StripeCustomerCouponStatus;
(function (StripeCustomerCouponStatus) {
    StripeCustomerCouponStatus[StripeCustomerCouponStatus["Available"] = 0] = "Available";
    StripeCustomerCouponStatus[StripeCustomerCouponStatus["Used"] = 1] = "Used";
})(StripeCustomerCouponStatus = exports.StripeCustomerCouponStatus || (exports.StripeCustomerCouponStatus = {}));
//# sourceMappingURL=Stripe.js.map